export enum TypeOfDelivery {
    VAGINAL = "Vaginal",
    C_SECTION_SCHEDULED = "C-Section (scheduled)",
    C_SECTION_EMERGENCY = "C-Section (emergency)",
    COMPLICATIONS = "Complications of pregnancy"
}